import { Reference } from '@apollo/client';

import useMutationWithValidation from '@hooks/useMutationWithValidation';
import { ProviderDestroyDocument, ProviderDestroyMutation, ProviderDestroyMutationVariables } from '@typing/Generated';

const useDestroyProvider = (journeyId: string) => {
  const [mutation] = useMutationWithValidation<ProviderDestroyMutation, ProviderDestroyMutationVariables>(
    ProviderDestroyDocument,
    'provider',
    {
      update: (store, { data }) => {
        if (data?.providerDestroy) {
          store.modify({
            fields: {
              providers(cachedProviderRefs: readonly Reference[], { readField }) {
                return cachedProviderRefs.filter(
                  providerRef => data.providerDestroy?.id !== readField('id', providerRef)
                );
              }
            },
            id: store.identify({ __typename: 'Journey', id: journeyId })
          });
        }
      }
    }
  );

  return mutation;
};

export default useDestroyProvider;
